export default "/images/a6934ec8d4cf70e07453f3239a4b0c6f.avif";